export function cssGet(element) {
    return getComputedStyle(element);
}

export function cssSet(element, obj) {
    for (const key in obj) {
        let val = obj[key];
        if (typeof val === "number") {
            val = `${val}px`;
        }
        element.style[key] = val;
    }
    return element;
}
